import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { APIRequestResources, CachedAPIRequest, LoadingService } from '../../../core';
import { WorkOrderFindDTO } from '../interface/frape-integration.entity';

@Injectable({
  providedIn: 'root'
})
export class FrappeIntegrationService extends CachedAPIRequest {

  loading = inject(LoadingService);

  constructor(protected override http: HttpClient, private router: Router) {
    super(http, APIRequestResources.FrappeIntegrationService);
  }

  findWorkOrder = (
    productionPlanOrParams: string | { production_plan?: string; operation?: string },
    operation?: string,
    refresh = true
  ) => {
    let params: any = {};
    if (typeof productionPlanOrParams === 'string') {
      params = { production_plan: productionPlanOrParams };
      if (operation) {
        params.operation = operation;
      }
    } else {
      params = productionPlanOrParams;
    }

    return this.get<WorkOrderFindDTO[]>(
      { endpoint: 'find-work-order', params },
      refresh ? 'freshness' : 'performance'
    );
  };
}
